import { createFileRoute } from "@tanstack/react-router";
import { FormRulesTabPanel } from "@/features/form-editor";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/form/rules",
)({
	component: FormRulesTabPanel,
});
